export default {
  name: 'PageFooter',
  data () {
    return {
    }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/global/pageFooter/pageFooter.component.js